<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
        >view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <div class="row dblock">
              <div class="row">
                <div class="col-md-12">
                  <vs-breadcrumb
                    align="left"
                    :items="[
                      { title: 'You are here : ' },
                      { title: 'Training Setup', active: true }
                    ]"
                  ></vs-breadcrumb>
                  <div class="heading mt-3">
                    <h3 class="text-secondary">Training Setup</h3>
                  </div>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mt-4">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 class="mb-0">WhatsApp System Config</h5>
                    <small class="text-muted">Toggle to instantly update.</small>
                  </div>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    @click="ensureConfig"
                    :disabled="isLoading"
                  >
                    <span v-if="isLoading">Refreshing...</span>
                    <span v-else>Refresh</span>
                  </button>
                </div>

                <div class="list-group list-group-flush">
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Advisor</div>
                      <small class="text-muted">Training Notification To Advisor</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.trainingNotificationToAdvisor"
                      @change="onToggle('trainingNotificationToAdvisor', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Program Officer</div>
                      <small class="text-muted">Training Assigned To Program Officer</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.trainingAssignedToPo"
                      @change="onToggle('trainingAssignedToPo', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Trainer</div>
                      <small class="text-muted">Trainer Nomination</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.trainerNomination"
                      @change="onToggle('trainerNomination', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Trainee</div>
                      <small class="text-muted">Trainee Nomination</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.traineeNomination"
                      @change="onToggle('traineeNomination', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                   <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Trainer Registration</div>
                      <small class="text-muted">trainerRegistration</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.trainerRegistration"
                      @change="onToggle('trainerRegistration', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Program Officer & Advisor</div>
                      <small class="text-muted">Media Notification To PO & Adv</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.mediaNotificationToPOAndAdv"
                      @change="onToggle('mediaNotificationToPOAndAdv', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                  <div class="list-group-item d-flex align-items-center justify-content-between">
                    <div>
                      <div class="font-weight-bold">Password Reset</div>
                      <small class="text-muted">passwordReset</small>
                    </div>
                    <b-form-checkbox
                      switch
                      size="lg"
                      :checked="flags.passwordReset"
                      @change="onToggle('passwordReset', $event)"
                      :disabled="isSaving || isLoading || !configId"
                    ></b-form-checkbox>
                  </div>
                </div>

                <div class="mt-3">
                  <span v-if="isSaving" class="text-muted">Saving...</span>
                  <span v-else-if="!configId" class="text-muted">Preparing config...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const defaultFlags = config => ({
  trainingNotificationToAdvisor: true,
  trainingAssignedToPo: true,
  trainerNomination: true,
  traineeNomination: true,
  trainerRegistration: true,
  mediaNotificationToPOAndAdv: true,
  passwordReset: true,
  ...(config || {})
});

const normalizeConfig = raw => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }
  return raw;
};

export default {
  data: () => ({
    isSidebar: false,
    isLoading: false,
    isSaving: false,
    configId: null,
    flags: defaultFlags()
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  mounted() {
    axios.defaults.headers["Authorization"] = localStorage.getItem("token");
    this.ensureConfig();
  },
  methods: {
    ensureConfig() {
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/systems-config")
        .then(res => {
          const list = Array.isArray(res.data) ? res.data : [];
          const existing = list.find(item => item.name === "WhatsApp");
          if (existing) {
            this.configId = existing.id;
            this.flags = defaultFlags(normalizeConfig(existing.config));
            return null;
          }
          return axios
            .post(process.env.VUE_APP_BASE_PATH + "/systems-config", {
              name: "WhatsApp",
              config: defaultFlags()
            })
            .then(createRes => {
              if (createRes.data?.error) throw new Error(createRes.data.error);
              this.configId = createRes.data.success?.id || null;
              this.flags = defaultFlags(normalizeConfig(createRes.data.success?.config));
            });
        })
        .catch(err => {
          this.toastError(err.response?.data?.error || err.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onToggle(key, value) {
      if (!this.configId) return;
      const updated = { ...this.flags, [key]: value };
      this.isSaving = true;
      axios
        .put(`${process.env.VUE_APP_BASE_PATH}/systems-config/${this.configId}`, {
          name: "WhatsApp",
          config: updated
        })
        .then(res => {
          if (res.data?.error) throw new Error(res.data.error);
          this.flags = updated;
          this.toastSuccess("Updated");
        })
        .catch(err => {
          this.toastError(err.response?.data?.error || err.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 2500,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 3000,
        variant: "danger",
        solid: true
      });
    }
  }
};
</script>

<style scoped>
.myNavbar {
  color: #fff;
}
</style>
